import { CloseButton, DialogSubTitle, DialogToolbar } from 'apps/wrapper/src/components/shared/dialog/dialog.styles';
import moment from 'moment';
import { FC } from 'react';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const PayerUnableToRespondDialog: FC = (props) => {
  const { opened, onClose, isLoading, appointmentRequest, ivSummary } = useApptRequestIvStatusDialog();

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.firstName}`}</BoldText>
          {ivSummary?.dateReceived && <>&nbsp;- Run {moment.utc(ivSummary.dateReceived).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        We were unable to confirm the verification status of this patient due to unresponsive systems from the payer.
        Please reach out to the payer directly to manually verify the patient or mark them as self-pay.
      </DialogSubTitle>
      <IvInfo />
      <br /> <br />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(PayerUnableToRespondDialog);
